import { Directive } from "@angular/core";

@Directive({
    selector: '[t4ItemFilter]',
    standalone: false
})
  export class ItemFilterDirective {}
